import { styled } from 'styles';

export const TableBody = styled.div`
  position: relative;
  user-select: none;
`;

export const TableMessage = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
  min-height: 12em;
  text-align: center;
  user-select: none;
  z-index: 1;
`;

export const StyledTable = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
`;
